import { SwishConsent } from 'src/modules/invoice/models/swishConsent';
import { SwishConsentSearchFilter } from 'src/modules/invoice/models/swishConsentSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setPagingParams } from '../functions/createPagingParams';
import { setArrayValue } from '../functions/setArrayValue';

const controller = 'SwishConsent';

export const getAllSwishConsents = (searchFilter: SwishConsentSearchFilter) => {
  const pageIndex = searchFilter?.pageIndex ?? 0;
  const pageSize = searchFilter?.pageSize ?? 50;
  const sortCol = searchFilter?.sortCol ?? 'createdAt';
  const sortDir = searchFilter?.sortDir ?? 'desc';

  // Bygg query som autogiro: statusList som upprepade params, linkedFilter som enkel param.
  let extraQuery = '';
  extraQuery += searchFilter?.filter ? `&filter=${searchFilter.filter}` : '';
  extraQuery += setArrayValue(searchFilter?.status, 'statusList');
  extraQuery += searchFilter?.linkedFilter ? `&linkedFilter=${searchFilter.linkedFilter}` : '';

  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<SwishConsent>>(endpoint);
};

export const getSwishConsentById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<SwishConsent>(endpoint);
};

// Återkalla medgivande (Swish consent). Backend gör DELETE mot Swish recurring/consents/{consentId}
// och avslutar ev. kopplad prenumeration (inv_swishStatus för medlem).
export const revokeSwishConsent = (swishConsentId: number) => {
  const endpoint = `${controller}/consent/${swishConsentId}`;
  return AxiosInstance.delete(endpoint);
};
